import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { LearnerService } from '../../services/learner.service';
import { MatSort, MatTableDataSource, MatPaginator, MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material';
import { Router, NavigationExtras } from '@angular/router';
import * as _ from 'lodash';
import { UtilityService } from 'src/app/services/utility.service';
import { CompetencyDetailModalComponent } from 'src/app/competency/competency-detail-modal/competency-detail-modal.component';
import { config } from '../../_models/userCompetency';
import { userRolesList } from 'src/app/_models/staticArray';
import { Observable } from 'rxjs';
@Component({
  selector: 'app-learner-list',
  templateUrl: './learner-list.component.html',
  styleUrls: ['./learner-list.component.scss']
})
export class LearnerListComponent implements OnInit {

  users = []
  loading: boolean;
  learner = []
  pageSizeOptions: number[] = [25, 50, 100];
  displayedColumns: string[] = ['name', 'email', 'competency', 'actions'];
  searchText
  dataSource: MatTableDataSource<any>;
  paginator: MatPaginator;
  sort: MatSort
  view = false;
  afterFilter = {
    title: "No Learner Found!",
    data: 'Sorry, no learner matched your search'
  }
  filterActive
  noDataMsg = {
    title: 'No Learner!',
    data: 'You have not added any learner yet.'
  }
  title = [];
  module;

  @ViewChild(MatSort, { static: true }) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }

  @ViewChild(MatPaginator, { static: true }) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  constructor(
    public _learnerService: LearnerService,
    private router: Router,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    public _utilityService: UtilityService,
    public _cd: ChangeDetectorRef
  ) {
    this.learner = []
    this.dataSource = new MatTableDataSource();
  }

  ngOnInit() {
    this.loading = true;
    this.getAllLearners()
    this.module = JSON.parse(localStorage.getItem('module'))
    if (this.module.isTrainingJob && this.module.isLabourjob) {
      this.users = ['trainer', 'IQA', 'client', 'admin']
    }
    if (this.router.url.includes('/dashboard')) {
      this.view = true;
    }
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    if (this.paginator && this.paginator._intl) {
      const paginatorIntl = this.paginator._intl;
      paginatorIntl.nextPageLabel = '';
      paginatorIntl.previousPageLabel = '';
    }

  }


  // API CALL



  // GET ALL LEARNERS FROM ALL JOBS
  getAllLearners() {
    this._learnerService.getAllLearners().subscribe((res) => {

      this.learner = res;
      this.updateData(this.learner);
      console.log("ALL LEARNERS DATA", this.learner, res)
    }, error => {
      console.log("ERROR WHILE GET LEARNER DATA", error)
    })
  }

  updateData(learner) {
    this.dataSource = new MatTableDataSource(learner);
    // add dataSource.sortingDataAccessor
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.loading = false;
    this._cd.detectChanges();
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }

  goToSingleLearner(learner) {
    console.log("SINGLE LEANER DATA", learner)
    if (learner && learner.jobs && learner.jobs.length) {
      let jobId = learner.jobs[0]._id
      this.router.navigate(['/learner/view/' + learner._id], { queryParams: { job: jobId } })
    } else {
      this._utilityService.handleSnackBar({ msg: 'No job found for this learner', action: 'OK' })
    }
  }

  openModal(competencies) {
    let data = {
      competencies: competencies,

    }
    let competency = this._utilityService.commonDialogBoxOpen(CompetencyDetailModalComponent, data)
  }

  filter(searchText) {
    this.dataSource.filter = searchText.trim().toLowerCase();
    console.log("inside filter: ", searchText, this.dataSource.filteredData)
    if (this.dataSource.filteredData.length == 0) this.filterActive = true
    else this.filterActive = false
  }
}
